import { TreatmentScanType, TreatmentType } from 'app/core/enums';

export const ScanFileColor = '#1EE408';
export const ExcludeScanTypes = [TreatmentScanType.MonolithicTryInDentureStl];
export const OutputModelColors = [
  { treatmentType: TreatmentType.NightGuard, modelColor: '#777DC4', crossColor: '#303BBA' },
  {
    treatmentType: TreatmentType.SmileDesign,
    modelColor: '#ab9184',
    crossColor: '#ab6543',
    treatmentFiles: [
      { fileType: TreatmentScanType.TrialSmileUpperStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.TrialSmileLowerStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.WaxUpUpperStl, modelColor: '#C59C62', crossColor: '#C4872F' },
      { fileType: TreatmentScanType.WaxUpLowerStl, modelColor: '#C59C62', crossColor: '#C4872F' },
    ],
  },
  { treatmentType: TreatmentType.BracketRemoval, modelColor: '#C59C62', crossColor: '#C4872F' },
  { treatmentType: TreatmentType.SurgicalGuide, modelColor: '#BBAE91', crossColor: '#BA9747' },
  { treatmentType: TreatmentType.SmileCorrect, modelColor: '#BBAE91', crossColor: '#BA9747' },
  { treatmentType: TreatmentType.RemovablePartialDenture, modelColor: '#C59C62', crossColor: '#C4872F' },
  { treatmentType: TreatmentType.ClearAligner, modelColor: '#C59C62', crossColor: '#C4872F' },
  { treatmentType: TreatmentType.SingleImplantWithCrown, modelColor: '#B0B0B0', crossColor: '#626262' },
  {
    treatmentType: TreatmentType.CrownAndBridge,
    modelColor: '#B0B0B0',
    crossColor: '#626262',
    treatmentFiles: [
      { fileType: TreatmentScanType.RemovableDieStl, modelColor: '#C59C62', crossColor: '#C4872F' },
      { fileType: TreatmentScanType.CementedRestorationStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.UpperJaw, modelColor: '#C59C62', crossColor: '#C4872F' },
      { fileType: TreatmentScanType.LowerJaw, modelColor: '#C59C62', crossColor: '#C4872F' },
    ],
  },
  {
    treatmentType: TreatmentType.ImplantRestorations,
    modelColor: '#B0B0B0',
    crossColor: '#626262',
    treatmentFiles: [
      { fileType: TreatmentScanType.RemovableDieStl, modelColor: '#C59C62', crossColor: '#C4872F' },
      { fileType: TreatmentScanType.ImplantCrownStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.ImplantShellTempStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.ImplantBridgeStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.UpperJaw, modelColor: '#C59C62', crossColor: '#C4872F' },
      { fileType: TreatmentScanType.LowerJaw, modelColor: '#C59C62', crossColor: '#C4872F' },
    ],
  },
  { treatmentType: TreatmentType.CustomBleachingTray, modelColor: '#C59C62', crossColor: '#C4872F' },
  {
    treatmentType: TreatmentType.RemovableDentures,
    modelColor: '#EFDAC6',
    crossColor: '#C4872F',
    treatmentFiles: [
      { fileType: TreatmentScanType.DentureTeethStl, modelColor: '#F8EFE7', crossColor: '#999999' },
      { fileType: TreatmentScanType.DentureGumBaseStl, modelColor: '#C6839A', crossColor: '#F52F2F' },
      { fileType: TreatmentScanType.UpperAntagonist, modelColor: '#C59C62', crossColor: '#C4872F' },
      { fileType: TreatmentScanType.LowerAntagonist, modelColor: '#C59C62', crossColor: '#C4872F' },
    ],
  },
  { treatmentType: TreatmentType.AINightGuard, modelColor: '#777DC4', crossColor: '#303BBA' },
  { treatmentType: TreatmentType.HybridDentures, modelColor: '#DDDDDD', crossColor: '#999999' },
  {
    treatmentType: TreatmentType.AICrown,
    modelColor: '#B0B0B0',
    crossColor: '#626262',
    treatmentFiles: [{ fileType: TreatmentScanType.AICrownDieStl, modelColor: '#C59C62', crossColor: '#C4872F' }],
  },
  {
    treatmentType: TreatmentType.Veneers,
    modelColor: '#ab9184',
    crossColor: '#ab6543',
    treatmentFiles: [
      { fileType: TreatmentScanType.VeneersStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.UpperJaw, modelColor: '#ab9184', crossColor: '#ab6543' },
      { fileType: TreatmentScanType.LowerJaw, modelColor: '#ab9184', crossColor: '#ab6543' },
    ],
  },
  {
    treatmentType: TreatmentType.NeerCrystal,
    modelColor: '#ab9184',
    crossColor: '#ab6543',
    treatmentFiles: [
      { fileType: TreatmentScanType.VeneersStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.UpperJaw, modelColor: '#ab9184', crossColor: '#ab6543' },
      { fileType: TreatmentScanType.LowerJaw, modelColor: '#ab9184', crossColor: '#ab6543' },
    ],
  },
  {
    treatmentType: TreatmentType.Moment,
    modelColor: '#ab9184',
    crossColor: '#ab6543',
    treatmentFiles: [
      { fileType: TreatmentScanType.VeneersStl, modelColor: '#B0B0B0', crossColor: '#626262' },
      { fileType: TreatmentScanType.UpperJaw, modelColor: '#ab9184', crossColor: '#ab6543' },
      { fileType: TreatmentScanType.LowerJaw, modelColor: '#ab9184', crossColor: '#ab6543' },
    ],
  },
  {
    treatmentType: TreatmentType.DentalModel,
    modelColor: '#ab9184',
    crossColor: '#ab6543',
    treatmentFiles: [
      { fileType: TreatmentScanType.DentalModelDieStl, modelColor: '#C59C62', crossColor: '#C4872F' },
      { fileType: TreatmentScanType.UpperJaw, modelColor: '#C59C62', crossColor: '#C4872F' },
      { fileType: TreatmentScanType.LowerJaw, modelColor: '#C59C62', crossColor: '#C4872F' },
    ],
  },
  { treatmentType: TreatmentType.Custom, modelColor: '#C59C62', crossColor: '#C4872F' },
  {
    treatmentType: TreatmentType.AIRetainer,
    modelColor: '#777DC4',
    crossColor: '#303BBA',
    treatmentFiles: [
      { fileType: TreatmentScanType.UpperJawRetainer, modelColor: '#777DC4', crossColor: '#303BBA' },
      { fileType: TreatmentScanType.LowerJawRetainer, modelColor: '#777DC4', crossColor: '#303BBA' },
    ],
  },
  {
    treatmentType: TreatmentType.ManualRetainer,
    modelColor: '#777DC4',
    crossColor: '#303BBA',
    treatmentFiles: [
      { fileType: TreatmentScanType.UpperJawRetainer, modelColor: '#777DC4', crossColor: '#303BBA' },
      { fileType: TreatmentScanType.LowerJawRetainer, modelColor: '#777DC4', crossColor: '#303BBA' },
    ],
  },
];

export type ColorConfig = (typeof OutputModelColors)[number];
